import { render, staticRenderFns } from "./ColorPaymentDay.vue?vue&type=template&id=1307c0ae&scoped=true&functional=true&"
import script from "./ColorPaymentDay.vue?vue&type=script&lang=js&"
export * from "./ColorPaymentDay.vue?vue&type=script&lang=js&"
import style0 from "./ColorPaymentDay.vue?vue&type=style&index=0&id=1307c0ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "1307c0ae",
  null
  
)

export default component.exports